import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1191. 支払タスク按分対象外費用編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/update_non_allocable_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  non_allocable_amount: number;
};

const updateNonAllocableAmount = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/update_non_allocable_amount`,
    props
  );
};

export const useUpdateNonAllocableAmount = () => {
  return useMutation({
    mutationFn: updateNonAllocableAmount,
  });
};
